'use strict'

require '../../src/frontend/core/dom_js_shim'

$ = window.$ = window.jQuery = require 'jquery'
require('../../src/frontend/core/jquery.safe-ready') $
require('../../src/frontend/core/jquery.addons') $
require('./groupon_modules/placeholder_field') $
require('./common/core_libraries')
